import * as React from 'react';
import { FlashList, FlashListProps, FlashListRef } from '@shopify/flash-list';

export type ListProps<ItemT> = {
  data: FlashListProps<ItemT>['data'];
  threshold?: number;
  onEndReached?: () => void;
  renderItem: FlashListProps<ItemT>['renderItem'];
  getItemType?: FlashListProps<ItemT>['getItemType'];
  extraData?: FlashListProps<ItemT>['extraData'];
  ListFooterComponent?: FlashListProps<ItemT>['ListFooterComponent'];
  ListHeaderComponent?: FlashListProps<ItemT>['ListHeaderComponent'];
  ListHeaderComponentStyle?: FlashListProps<ItemT>['ListHeaderComponentStyle'];
  numberOfColumns?: number;
  scrollIndicatorInsets?: FlashListProps<ItemT>['scrollIndicatorInsets'];
  keyExtractor: FlashListProps<ItemT>['keyExtractor'];
  contentContainerStyle?: FlashListProps<ItemT>['contentContainerStyle'];
  ItemSeparatorComponent?: FlashListProps<ItemT>['ItemSeparatorComponent'];
  stickyHeaderIndices?: FlashListProps<ItemT>['stickyHeaderIndices'];
  onScroll?: FlashListProps<ItemT>['onScroll'];
  onLayout?: FlashListProps<ItemT>['onLayout'];
  refreshControl?: FlashListProps<ItemT>['refreshControl'];
  maintainVisibleContentPosition?: FlashListProps<ItemT>['maintainVisibleContentPosition'];
  listRef?: React.ForwardedRef<ListRef<ItemT>> | null;
};

export type ListRef<T> = {
  // scrollToIndex: FlashList<T>['scrollToIndex'];
  scrollToItem: FlashListRef<T>['scrollToItem'];
};

export const List = <T,>({
  contentContainerStyle,
  data,
  ItemSeparatorComponent,
  keyExtractor,
  ListFooterComponent,
  ListHeaderComponent,
  ListHeaderComponentStyle,
  numberOfColumns = 1,
  onEndReached,
  renderItem,
  scrollIndicatorInsets,
  threshold = 0.9,
  extraData,
  stickyHeaderIndices,
  onScroll,
  refreshControl,
  getItemType,
  maintainVisibleContentPosition,
  listRef,
  onLayout,
}: ListProps<T>): // ref: React.ForwardedRef<ListRef<T>>,
React.ReactElement => {
  const flastListRef = React.useRef<FlashListRef<T>>(null);

  React.useImperativeHandle(
    listRef,
    () => ({
      // scrollToIndex: (...args) => flastListRef.current!.scrollToIndex(...args),
      scrollToItem: (...args) => flastListRef.current!.scrollToItem(...args),
    }),
    [flastListRef],
  );

  return (
    <FlashList
      ref={flastListRef}
      refreshControl={refreshControl}
      onScroll={onScroll}
      contentContainerStyle={contentContainerStyle}
      scrollIndicatorInsets={scrollIndicatorInsets}
      key={numberOfColumns}
      numColumns={numberOfColumns}
      keyExtractor={keyExtractor}
      data={data}
      extraData={extraData}
      renderItem={renderItem}
      onEndReachedThreshold={threshold}
      onEndReached={onEndReached}
      ListHeaderComponentStyle={ListHeaderComponentStyle}
      ListHeaderComponent={ListHeaderComponent}
      ListFooterComponent={ListFooterComponent}
      ItemSeparatorComponent={ItemSeparatorComponent}
      stickyHeaderIndices={stickyHeaderIndices}
      getItemType={getItemType}
      showsVerticalScrollIndicator
      maintainVisibleContentPosition={maintainVisibleContentPosition}
      onLayout={onLayout}
    />
  );
};
